import { getLineItemImageUrl } from '../../../../../utils/get-line-item-image-url.js';
import { getLineItemName } from '../../../../../utils/get-line-item-name.js';

const getSolutionProperties = (solutionProduct, intl, settings)=>{
    return {
        solutionSku: solutionProduct.sku,
        solutionName: getLineItemName(solutionProduct, intl),
        solutionImageUrl: getLineItemImageUrl(solutionProduct.masterData.current.variant, settings.staticsUrl, settings.isBynderImagesEnabled)
    };
};

export { getSolutionProperties };
//# sourceMappingURL=get-solution-properties.js.map
